import holidaysList from '../../data/holidays.json';

export function normalizeHolidays(): { [key: string]: string } {
  const r: { [key: string]: string } = {};
  holidaysList.forEach(function (h) {
    const key = h.date.substring(0, 10);
    r[key] = h.description;
  });
  return r;
}
